import { BaseService } from './base.service';
import {
  UserRegistrationRequest,
  UserRegistrationResponse,
} from '../models/registration/user-registration.model';

export class RegistrationService {
  static async Register(
    data: UserRegistrationRequest
  ): Promise<UserRegistrationResponse> {
    try {
      const url = BaseService.BuildUrl(`/public/user-registrations`);
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        let errorMessage = `Error: ${response.status}`;
        try {
          const errorJson = await response.json();
          errorMessage = `${response.status} - ${errorJson.message}`;
        } catch {}
        throw new Error(errorMessage);
      }

      const json = await response.json();
      return json as UserRegistrationResponse;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
}
